 // Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import _ from "lodash";
import React, { RefObject } from "react";
import { connect } from "react-redux";
//import { RouteComponentProps } from "react-router-dom";
import { RouteComponentProps, Link } from "react-router-dom";
import SplitPane from "react-split-pane";
import { bindActionCreators } from "redux";
import { PrimaryButton } from "@fluentui/react";
import HtmlFileReader from "../../../../common/htmlFileReader";
import { strings, interpolate } from "../../../../common/strings";
import {
    AssetState, AssetType, EditorMode, FieldType,
    IApplicationState, IAppSettings, IAsset, IAssetMetadata,
    ILabel, IProject, IRegion, ISize, ITag, FeatureCategory, FieldFormat,
    IAuthenticationState
} from "../../../../models/applicationState";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IAppTitleActions, * as appTitleActions from "../../../../redux/actions/appTitleActions";
import { AssetPreview, ContentSource } from "../../common/assetPreviewFR/assetPreview";
import { KeyboardBinding } from "../../common/keyboardBinding/keyboardBinding";
import { KeyEventType } from "../../common/keyboardManager/keyboardManager";
import { TagInput } from "../../common/tagInputFR/tagInput";
import { tagIndexKeys } from "../../common/tagInputFR/tagIndexKeys";
//import Canvas from "./canvas";
//import { TableView } from "./tableView"
//import CanvasHelpers from "./canvasHelpers";
import "./admin.scss";
//import EditorSideBar from "./editorSideBar";
import Alert from "../../common/alert/alert";
import Confirm from "../../common/confirm/confirm";
import { OCRService } from "../../../../services/ocrService";
import { throttle } from "../../../../common/utils";
import { constants } from "../../../../common/constants";
import PreventLeaving from "../../common/preventLeaving/preventLeaving";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { getPrimaryGreenTheme, getPrimaryRedTheme } from "../../../../common/themes";
import { toast } from "react-toastify";
import { PredictService } from "../../../../services/PredictService";
import { AssetService } from "../../../../services/assetService";
import BeforeUnloadComponent from "react-beforeunload-component";
import { SkipButton } from "../../shell/skipButton";
import ModalHeader from "../header/subHeader";
import ODModalHeader from "../header/ODsubHeader";
import HeaderComponent from "../header/header";
import size from "lodash/size";
import { StatusBar } from "../../shell/statusBar";
import { StatusBarMetrics } from "../../shell/statusBarMetrics";
import { updateUserFeaturesByIdEndPoint,accessToken ,docMgt_UpdateStatus,headers } from "../../../../common/api-config";

//import AdvancedHeader from "../header/advancedHeader"; 
//import 'react-dual-listbox/lib/react-dual-listbox.css';
import Select from "react-select";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import IUserDefinedActions, * as userDefinedActions from "../../../../redux/actions/userDefinedActions";
//import { headers } from "../../../../common/api-config";
import axios from "axios";
import LoadingOverlay from "react-loading-overlay";

/**
 * Properties for Editor Page
 * @member project - Project being edited
 * @member recentProjects - Array of projects recently viewed/edited
 * @member actions - Project actions
 * @member applicationActions - Application setting actions
 */
export interface IEditorPageProps extends RouteComponentProps, React.Props<Admin> {
    project: IProject;
    recentProjects: IProject[];
    appSettings: IAppSettings;
    actions: IProjectActions;
    applicationActions: IApplicationActions;
    appTitleActions: IAppTitleActions;
    loggedInUser: IAuthenticationState;
    loadAnnotateFiles: IAsset[];
    userOperationsActions: IUserOperationsActions;
	userDefinedActions: IUserDefinedActions;
}

/**
 * State for Editor Page
 */
export interface IEditorPageState {
    /** Array of assets in project */
    assets: IAsset[];
    /** The editor mode to set for canvas tools */
    editorMode: EditorMode;
    /** The selected asset for the primary editing experience */
    selectedAsset?: IAssetMetadata;
    /** Currently selected region on current asset */
    selectedRegions?: IRegion[];
    /** Most recently selected tag */
    selectedTag: string;
    /** Tags locked for region labeling */
    lockedTags: string[];
    /** Size of the asset thumbnails to display in the side bar */
    thumbnailSize: ISize;
    /**
     * Whether or not the editor is in a valid state
     * State is invalid when a region has not been tagged
     */
    isValid: boolean;
    /** Whether the show invalid region warning alert should display */
    showInvalidRegionWarning: boolean;
    /** Show tags when loaded */
    tagsLoaded: boolean;
    /** The currently hovered TagInputItemLabel */
    hoveredLabel: ILabel;
    /** Whether the task for loading all OCRs is running */
    isRunningOCRs?: boolean;
    /** Whether OCR is running in the main canvas */
    isCanvasRunningOCR?: boolean;
    isCanvasRunningAutoLabeling?: boolean;
    isError?: boolean;
    errorTitle?: string;
    errorMessage?: string;
    tableToView: object;
    tableToViewId: string;
    selectedOcrFile: any;

    userId: string;
    selectedUserId: any,
    usersList:any,
    allFeatures:any,
    selected:any,
    loadingProjects: boolean;
    loaderText: string;
    isUseridSelected:boolean;
    AlluserfeaturesList:any;
    selectedIdFeatures:any;
}

function mapStateToProps(state: IApplicationState) {
    return {
        recentProjects: state.recentProjects,
        project: state.currentProject,
        appSettings: state.appSettings,
        loggedInUser: state.loggedInUser,
        loadAnnotateFiles: state.loadAllFiles,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        applicationActions: bindActionCreators(applicationActions, dispatch),
        appTitleActions: bindActionCreators(appTitleActions, dispatch),
        userOperationsActions: bindActionCreators(userOperationsActions, dispatch),
		userDefinedActions:bindActionCreators(userDefinedActions, dispatch), 
    };
}

/**
 * @name - Editor Page
 * @description - Page for adding/editing/removing tags to assets
 */
@connect(mapStateToProps, mapDispatchToProps)
export default class Admin extends React.Component<IEditorPageProps, IEditorPageState> {
    public state: IEditorPageState = {
        selectedTag: null,
        lockedTags: [],
        assets: [],
        editorMode: EditorMode.Select,
        thumbnailSize: { width: 175, height: 155 },
        isValid: true,
        showInvalidRegionWarning: false,
        tagsLoaded: false,
        hoveredLabel: null,
        tableToView: null,
        tableToViewId: null,
        selectedOcrFile: null,

        userId: null,
        selectedUserId: null,
        usersList:[],
        allFeatures:[],
        selected:[],
        loadingProjects: false,
        loaderText: "Loading...",
        isUseridSelected:false,
        AlluserfeaturesList:null,
        selectedIdFeatures:null

    };

    private tagInputRef: RefObject<TagInput>;

    private loadingProjectAssets: boolean = false;
    //private canvas: RefObject<Canvas> = React.createRef();
    private renameTagConfirm: React.RefObject<Confirm> = React.createRef();
    private renameCanceled: () => void;
    private deleteTagConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteDocumentConfirm: React.RefObject<Confirm> = React.createRef();
    private isUnmount: boolean = false;

    constructor(props) {
        super(props);
        this.tagInputRef = React.createRef();
    }

    public async componentDidMount() {
    //    window.addEventListener("focus", this.onFocused);
        this.isUnmount = false;
        await this.setState({loadingProjects:true})
       await this.loadDefaultFeatures();
       await this.setState({loadingProjects:false})
    
    }
  

    public async componentDidUpdate(prevProps: Readonly<IEditorPageProps>,prevState) {         
    }

    public componentWillUnmount() {
        // this.isUnmount = true;
     //   window.removeEventListener("focus", this.onFocused);
        // this.abortController.abort();
    }
    
    onChange = (selected, selection) => {
        console.log('The user highlighted these options', selection);
        this.setState({ selected });
    };
     
    private getUserIdbasedFeatures = async(event) => {
        debugger;
        const {  AlluserfeaturesList  } = this.state;
        if (event) {
            this.setState({ selectedUserId: event });
            
            
              //get all features -start
            //  let loggedid=this.props.loggedInUser.user.emails[0];
          let featuresList:any =[];  //await this.props.userOperationsActions.getFeaturesById(loggedid);
          let allfeatures=[];
          let fullfeatures=[];
         
         // this.setState({allFeatures:this.state.allFeatures});
         //get all features -end
       
     
            
            //get list of features for the selected Id start
            
           // toast.success("Fetching user features!", { position: toast.POSITION.TOP_CENTER });
            //
          //  let featuresList_s:any =  await this.props.userOperationsActions.getFeaturesById(event.value);
           
            let allfeatures_s=[];
            //
            let selectedIdFeatures = AlluserfeaturesList.find(c=>c.userid ===event.value);
     
          this.setState({ selected: this.state.allFeatures,selectedIdFeatures:selectedIdFeatures.features });             
             
        } else {
            this.setState({ selectedUserId: null });
        }
        this.setState({isUseridSelected:true})
    }

    //componentWillUnmount = () => this.abortController.abort();

//   abortController = new window.AbortController();

    public render() {
    
        const { project } = this.props;
        const { usersList,allFeatures,selected,isUseridSelected } = this.state;
 
        const options = [
            { value: 'one', label: 'Option One' },
            { value: 'two', label: 'Option Two' },
        ];
    // const selected= ['IDA'];
         
        

        return (

            <>
            <HeaderComponent
               history={this.props.history}
               match={this.props.match}
               location={this.props.location} />
               
			   <div className="container-fluid animated fadeIn">
                    <div className="row mt-5">
                        <div className="col-lg-2 " />
                        <div className="col-lg-8 ">
                            <div className="card CustomCard shadow">
							<div className="create-model">
                                    <div className="row">
                                        <div className="col-lg-3 ">
                                        </div>
                                    </div>
            
                
                
                  
									<div className="AdvWidth">
                                       <div className="text-center mt-3">
                                          
                                            <label htmlFor="createmodel"> <h5> Features Management</h5></label>
                                        </div>
                                        
                                    
                                <div className="row">
								<div className="col-lg-2 ">
									</div>
                                        <div className="col-lg-10 ">
                                  
                                
                                <div className="row">
                                <div className="col-lg-6">
                                    
                                <span> Select User ID:</span> <span className="text-info small note"></span>
                                        <Select options={usersList}
                                            value={this.state.selectedUserId}
                                            onChange={this.getUserIdbasedFeatures}
                                            className="react-select-container z-index-19"
                                            // isClearable={true}
                                            theme={(theme) => ({
                                                ...theme,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: "#161a1f",
                                                    primary: "#6b727d",
                                                    neutral0: "#222830",
                                                    neutral20: "#44474c",
                                                    neutral30: "#272c33",
                                                    neutral50: "#fff",
                                                    neutral80: "#9da7b5",
                                                },
                                            })}

                                        />
                                
                </div>
				<div className="col-lg-6">
					</div>
                                    </div>
                                    
                                    
                                    
                                <div className="row">
                                        <div className="col-md-12">
                                            
                                   
            {
             isUseridSelected?
			 <div className="mt-3">
            {this.featurestableDataShow()}</div>:<></>}
            </div>
            
             
            
           
                                   
                             
                             </div>
                               
                             </div>
                              
                                    </div>
                               
                               </div>
                               </div>
                                    
               
                 
                             
                
               
                 
              
		   </div>
                        </div>
                        <div className="col-lg-2 ">
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-lg-2 ">
                        </div>
                    </div>
                </div>
            
                    
            </>
        );
    }

    public featurestableDataShow = () => {
        const { allFeatures,selected,AlluserfeaturesList,selectedUserId,selectedIdFeatures } = this.state;
    
        let RuleStatus="ON";
      // let selectedIdFeatures = AlluserfeaturesList.find(c=>c.userid ===selectedUserId.value);
        return (
            <div >
                {allFeatures  ?
                    <div className="card  shadow model-data mt-2" style={{height:"200px" }} >
                          <div className="row"> 
                         
                          <div   className="col-md-4  ">
                          <h6> Feature Name  </h6> </div>
                                    <div   className="col-md-2 ">  <h6>ON/OFF </h6> </div>
                                    <div   className="col-md-4 ">
                                    <h6>  Feature Name  </h6></div>
                                    <div   className="col-md-2 ">  <h6>ON/OFF</h6> </div>
                                   
                            
                          
                                {allFeatures && allFeatures.map((model, index) => {
                                       
                                       //let fstatus = selected.indexOf(model.label)>-1?"ON":"OFF";
									   //slet fstatus = "ON";
                                       let fstatus ="OFF"; 
                                       if(selectedIdFeatures)
                                       {
                                        fstatus =  selectedIdFeatures.indexOf(model.label)>-1?"ON":"OFF"; 
                                       }
                                      // "Performance Metrics", "Document Management
                                       
                                    return (
                                        <div key={index} className="col-md-6">
                                            <table><tr> <td className="col-md-9">
                                            <div>{model.label}</div>    
                                            </td><td>                                         
                                           <div>                                             
                                           {fstatus==="ON"?                    
<div className="switch" onClick={e=> this.handleCheckClick(model)}>
<input type="checkbox"  checked={true} />    
  <span className="slider round"></span>
</div>:
<div className="switch" onClick={e=> this.handleCheckClick(model)}> 
<input type="checkbox"  checked={false}  />   
  <span className="slider round"></span>
</div>
              }
              
                                           </div> 
                                         </td> </tr></table>
                                          </div>
                                    );
                                })}
                                
                               
							 
                                <div className="col-md-4">               
                </div>
                <div className="col-md-8">         
                <button type="button" style={{  marginTop:"20%"}} onClick={() => this.setRoles()} className="btn">
                                            {"Submit"}
                                        </button> &nbsp;&nbsp;&nbsp;                                      
                                        <button type="button" style={{  marginTop:"20%"}} onClick={() => this.setRefresh()} className="btn">
                                            {"Refresh"}
                                        </button>                                       
            </div>
                                     
                               
                           
                        </div>
						<div>
						
							</div>
                    </div>
                    : <p className="text-center">No Data Available</p>}
            </div>
        );
    }

    public async handleCheckClick(model) {
      
        debugger;
        let {selectedIdFeatures} = this.state;
        
        if(selectedIdFeatures  === null)
        {
            selectedIdFeatures=[];
            selectedIdFeatures.push(model.label);
        }
        else if(selectedIdFeatures.indexOf(model.label)>-1)
        {
            let indx= selectedIdFeatures.indexOf(model.label);
            selectedIdFeatures.splice(indx,1);
        }
        else
        {
            selectedIdFeatures.push(model.label);
        }
        this.setState({ selectedIdFeatures});
        /*
        let selectedFeatures = this.state.selected; 
        if(selectedFeatures.indexOf(model.label)>-1)
        {
            let indx= selectedFeatures.indexOf(model.label);
            selectedFeatures.splice(indx,1);
        }
        else
        {
            selectedFeatures.push(model.label);
        }
        this.setState({ selected: selectedFeatures });
        */
        
        /*
        let result = this.state.allData;
        if (model != null) {
    
    
          result = result.map((element) => {
            if (element.id === model.id) {
              if (element.RuleStatus === "ON") {
                element.RuleStatus = "OFF";
              } else {
                element.RuleStatus = "ON";
              }
              return element;
            }
            else {
              return element;
            }
          });
        }
    
        this.setState({ myModels: result });
    */
   
        
      }
      
    // call function from child
    private onPageContainerClick = () => {
        // workaround: tagInput will not lost focus with olmap,
        // so we fire the blur event manually here
        //this.tagInputRef.current.triggerNewTagBlur();
    }

    

    // tslint:disable-next-line:no-empty
    private onPageClick = () => {
    }

    /**
     * Called when the asset side bar is resized
     * @param newWidth The new sidebar width
     */
    private onSideBarResize = (newWidth: number) => {
        this.setState({
            thumbnailSize: {
                width: newWidth,
                height: newWidth / (4 / 3),
            },
        });
       // this.resizeCanvas()
    }

    /**
     * Called when the asset sidebar has been completed
     */
    private onSideBarResizeComplete = () => {
        const appSettings = {
            ...this.props.appSettings,
            thumbnailSize: this.state.thumbnailSize,
        };

        this.props.applicationActions.saveAppSettings(appSettings);
    }

    /**
     * Called when a tag from footer is clicked
     * @param tag Tag clicked
     */
     
     
 
    private isBusy = (): boolean => {
        return this.state.isRunningOCRs || this.state.isCanvasRunningOCR || this.state.isCanvasRunningAutoLabeling;
    }

    public setRefresh = async () => {        
    window.location.reload();
    }
     
    public    loadDefaultFeatures = async () => {    
		debugger;    
            let userfeaturesList:any=[];
          //  let loggedid=this.props.loggedInUser.user.emails[0];
         let usersFeatures  = await this.props.userDefinedActions.getListofBusinessUsers();   
           let allUsers=[];
           userfeaturesList = usersFeatures;
      
           if(userfeaturesList!=null)
           {  
               userfeaturesList.map((users, i) => {
                  
                allUsers.push({label:users.userid, value:users.userid});
                   
               });
             
              }          
              //get all features -start
             // let featuresList:any =  await this.props.userOperationsActions.getFeaturesById(loggedid);
             // let allfeatures=[];
              let fullfeatures=[];
              
             //get all features -end
             fullfeatures.push({label:"My Models", value:"My Models"});
             fullfeatures.push({label:"Operations", value:"Operations"});
			 fullfeatures.push({label:"Performance Metrics", value:"Performance Metrics"});
			 fullfeatures.push({label:"Document Management", value:"Document Management"});
			 fullfeatures.push({label:"Order Management", value:"Order Management"});
             fullfeatures.push({label:"Admin", value:"Admin"});
			 
           this.setState({usersList:allUsers,allFeatures:fullfeatures,AlluserfeaturesList:userfeaturesList});
        }
    
    public setRoles = async () => {
        
        //get selected features    
        await this.setState({ loadingProjects: true});
        
       debugger;
        const { selectedUserId,selectedIdFeatures } = this.state;
     //  let selectedFeatures = this.state.selected;
     //  let selectedUserId:any =  this.state.selectedUserId?this.state.selectedUserId:null;
        
       if(selectedUserId!=null)
       {
        let selectUserId = selectedUserId.value?selectedUserId.value:"";
        if(selectUserId.length>1)
           {                            
      
        let updateUserFeaturesendpoint = updateUserFeaturesByIdEndPoint(selectUserId);// adv_insertFeaturesById(selectUserId,JSON.stringify(selectedFeatures));
        
        let body = {
            "selectedFeatures":selectedIdFeatures
            };
            console.log("body",body);
           toast.success("saving user settings!", { position: toast.POSITION.TOP_CENTER });   
      
       axios( updateUserFeaturesendpoint , { method: "POST" , data: body, headers}).
        then((resp) => {
          if (resp.status === 200 || resp.status === 201) {        
              toast.success("Records updated Sucessfully!", { position: toast.POSITION.TOP_CENTER });
              window.location.reload();
          }
        });
      
     
        
        
        
    }
    else{
        toast.error("Please select user id!", { position: toast.POSITION.TOP_CENTER });
    }
    }
    else{
        toast.error("Please select user id!", { position: toast.POSITION.TOP_CENTER });
    }
    }
 
   
}
